import { render, staticRenderFns } from "./VehiculosCompatible.vue?vue&type=template&id=4b898782&scoped=true&"
import script from "./VehiculosCompatible.vue?vue&type=script&lang=js&"
export * from "./VehiculosCompatible.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b898782",
  null
  
)

export default component.exports